var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFortinetLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 14.665,
    viewBox: "0 0 130 14.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(-53 -733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fortinet-logo-RGB",
    transform: "translate(53 733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M413.238,429.383h.448a.34.34,0,0,1,.211.07.286.286,0,0,1,.1.243.319.319,0,0,1-.1.248.308.308,0,0,1-.221.086h-.437Zm.794.821a.583.583,0,0,0,.216-.2.567.567,0,0,0,.081-.308.551.551,0,0,0-.551-.556h-.848v1.772h.308v-.637h.486l.335.637h.346l-.378-.7h0",
    transform: "translate(-285.474 -417.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M413.929,430.1a1.491,1.491,0,0,1-.54.54,1.469,1.469,0,0,1-1.48,0,1.491,1.491,0,0,1-.54-.54,1.394,1.394,0,0,1-.2-.74,1.415,1.415,0,0,1,.2-.745,1.437,1.437,0,0,1,.54-.54,1.469,1.469,0,0,1,1.48,0,1.437,1.437,0,0,1,.54.54,1.415,1.415,0,0,1,.2.745,1.393,1.393,0,0,1-.2.74m.329-1.415a1.739,1.739,0,0,0-2.83-.556,1.682,1.682,0,0,0-.373.54,1.66,1.66,0,0,0-.135.675,1.74,1.74,0,0,0,.508,1.232,1.712,1.712,0,0,0,1.226.508,1.735,1.735,0,0,0,1.6-1.064,1.756,1.756,0,0,0,0-1.35",
    transform: "translate(-284.55 -416.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M138.19,14.638h3.576V0H138.19V14.638Z",
    transform: "translate(-63.631 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M108.96,3.146h3.77V14.638h3.576V3.146h6.477V0H108.96Z",
    transform: "translate(-50.178 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M215.36,0V3.146h3.765V14.638h3.581V3.146h6.471V0Z",
    transform: "translate(-99.177 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M0,14.638H3.576V9.226H13.747V6.081H3.576V3.146H15.5V0H0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M185.01,14.638h14.622V11.492H188.586v-2.6h8.9V5.746h-8.9v-2.6h10.852V0H185.01Z",
    transform: "translate(-85.221 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M338.675,406.85H326.64V421.5h3.576V410.006h8.032a1,1,0,0,1,.994.993v10.5h3.576v-10.51a4.141,4.141,0,0,0-4.143-4.138",
    transform: "translate(-245.752 -406.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M265.422,412.116a.81.81,0,0,1-.81.809H256.4V410h8.216a.81.81,0,0,1,.81.809Zm-.367-5.266H252.82V421.5H256.4v-5.4h8.054a.815.815,0,0,1,.778.809V421.5H268.8v-4.656a2.082,2.082,0,0,0-1.08-1.824,3.942,3.942,0,0,0,1.259-2.887V410.8a3.941,3.941,0,0,0-3.943-3.944",
    transform: "translate(-211.756 -406.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M65.955,10.05H60.04v3.8h5.92v-3.8Z",
    transform: "translate(-27.647 -4.63)",
    fill: "#d9291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M46.09,23.893H52v-3.8H46.09Z",
    transform: "translate(-21.223 -9.255)",
    fill: "#d9291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M242.66,410.037a3.187,3.187,0,0,0-3.187-3.187H236.74v3.781h5.942Z",
    transform: "translate(-204.347 -406.85)",
    fill: "#d9291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M46.09,0V3.8H52V0H46.09Z",
    transform: "translate(-21.223 0)",
    fill: "#d9291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M32.13,10.05h0v3.8h5.915v-3.8Z",
    transform: "translate(-14.775 -4.63)",
    fill: "#d9291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M236.722,430.763h2.733a3.187,3.187,0,0,0,3.187-3.187v-.616H236.7Z",
    transform: "translate(-204.329 -416.114)",
    fill: "#d9291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M208.83,427.574a3.187,3.187,0,0,0,3.187,3.187h2.728V426.98H208.83Z",
    transform: "translate(-191.475 -416.123)",
    fill: "#d9291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M208.83,410.055v.616h5.915V406.89h-2.728a3.187,3.187,0,0,0-3.187,3.187",
    transform: "translate(-191.475 -406.868)",
    fill: "#d9291c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortinetLogo);
export default __webpack_public_path__ + "static/media/fortinet-logo.19360da8b2d9e6e1297f81e045b3fa40.svg";
export { ForwardRef as ReactComponent };